// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".comments-triggerer[data-v-a0eb26c2]{border:1px solid hsla(0,0%,100%,.12);border-radius:0 0 4px 4px;border-top:none}.comments-triggerer[data-v-a0eb26c2]:hover{background-color:#303030;cursor:pointer}.ps[data-v-a0eb26c2]{height:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
